{
  "decrease": "Vähennä {fieldLabel}",
  "increase": "Lisää {fieldLabel}",
  "numberField": "Numerokenttä"
}
